const pl: any = {
  'Bold': 'Pogrubienie',
  'Italic': 'Pochylenie',
  'Center': 'Wyśrodkuj',
  'Justify Left': 'Do lewej',
  'Justify Right': 'Do prawej',
  'Ordered List (1, 2, 3)': 'Lista numerowana (1, 2, 3)',
  'Bullet List': 'Lista nienumerowana',
  'Remove formatting.\nClears headings, bold, italic, underlined text, etc.': 'Usuwanie formatowania',
  'Code': 'Wstaw kod',
  'Headings (h1-h6)': 'Nagłówki (H1-H6)',
  'Hyperlink': 'Link do strony',
  'Underline': 'Podkreślenie',
  'Insert Image': 'Wstaw obrazek',
  'Insert Table': 'Wstaw tablekę'

};
export default pl;
